const dividerText = {
  Renderer: ({ children, data }) => (
    <>
      <div className="page-title">
        <h4>{data.title}</h4>
      </div>
      <div>{children}</div>
    </>
  ),
  id: "dividerText",
  title: "Divider Text",
  description: "Divider Text",
  version: "dividerText",
};

export default dividerText;
